module.exports = __webpack_public_path__ + "media/icons/radioblack-5ed6fb25.png";